module.exports = __webpack_public_path__ + "img/6372dc47caf0dd58540d78007a22612a.477c3127.png";